module.exports = __webpack_public_path__ + "c29eb39c3126d90eed98592d323763d8.png";